import { Cell } from '@adserve/adserve-react-components';
import React, { useContext, useState, useEffect } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { GetCampaignBurstsSummary } from '../../../services/CampaignsDataService';

const AirtimeBurstsTotalRow = ({
    scrollPx,
    rowHeight,
    visibleRows,
    sumAllLines,
    campaign,
    burstCount = 0
}) => {
    const { formatCurrency, formatNumber } = useContext(SystemSettingsContext);
    const [burstsSummary, setBurstsSummary] = useState([]);
    const [errorState, setErrorState] = useState('');

    const getCampaignBurstSummary = (campaignId) => {
        if (campaignId && burstCount > 0) {
            GetCampaignBurstsSummary(campaignId)
                .then((result) => {
                    setBurstsSummary(result);
                })
                .catch((error) => {
                    setErrorState(error.response.title);
                    setBurstsSummary([]);
                });
        }
    };

    useEffect(() => {
        getCampaignBurstSummary(campaign.id);
    }, [campaign, burstCount]);

    return (
        <>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ borderLeftWidth: 1, opacity: 1 }}
            ></Cell>
            <Cell
                align='center'
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ opacity: 1, justifyContent: 'flex-start' }}
            >
                {window.translate('Total Bursts')}
            </Cell>
            <Cell
                align='center'
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ opacity: 1 }}
            ></Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ opacity: 1 }}
            ></Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ opacity: 1 }}
            ></Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ opacity: 1 }}
            ></Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {sumAllLines('spots')}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {formatNumber(sumAllLines('impacts'))}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {burstsSummary?.basePopulation && formatNumber(burstsSummary?.baseReach / burstsSummary?.basePopulation * 100)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {burstsSummary?.baseOTH && formatNumber(burstsSummary?.baseOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {burstsSummary?.baseWeeklyOTH && formatNumber(burstsSummary?.baseWeeklyOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {formatNumber(sumAllLines('targetImpacts'))}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {burstsSummary?.targetPopulation &&
                    formatNumber((burstsSummary?.targetReach / burstsSummary?.targetPopulation) * 100)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {burstsSummary?.targetOTH && formatNumber(burstsSummary?.targetOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {burstsSummary?.targetWeeklyOTH && formatNumber(burstsSummary?.targetWeeklyOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, justifyContent: 'flex-end' }}
            >
                {formatCurrency(sumAllLines('spendDiscounted'))}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                style={{ fontWeight: 'normal', opacity: 1, width: 119, justifyContent: 'flex-start' }}
            ></Cell>
        </>
    );
};

export default AirtimeBurstsTotalRow;
